import styled from 'styled-components';

export const SubNavInnerContainer = styled.div`
  height: 64px;
  max-width: 1296px;
  display: flex;
  align-items: center;
  width: 100%;
  z-index: 2147483646 !important;
  transition: top 0.3s;
  padding: 0px 56px;
  justify-content: space-between;

  a {
    display: flex;
  }

  p {
    font-family: 'Sofia Pro';
    font-size: 16px;
    color: white;
    margin: 0 0 0 14px;
  }

  ul {
    margin: 0;
  }

  li {
    color: rgba(0, 0, 0, 0.85);
    list-style: none;
    display: inline-block;
    padding: 8px 15px;

    &:hover {
      background: #2b2b2b;
      border-radius: 4px;
    }
  }

  .subnav--logo {
    height: 34px;
  }

  .subnav--left {
    display: flex;
    align-items: center;
  }

  .subnav--right {
    display: flex;
    align-items: center;

    .sub-nav--arrow {
      display: none;
      z-index: 2147483647 !important;

      &:hover {
        cursor: pointer;
      }

      svg {
        font-size: 20px;
        color: white;
      }

      @media (max-width: 1191px) {
        display: flex;
        margin-left: 10px;
      }
    }
  }

  ul {
    display: flex;

    @media (max-width: 1191px) {
      display: none;
    }
  }

  .subnav--logo {
    @media (max-width: 576px) {
      width: 112px;
    }
  }

  @media (max-width: 992px) {
    padding: 0 28px;
  }

  @media (max-width: 576px) {
    padding: 0 20px;
  }
`;

export const SubNavContainer = styled.div`
  height: 64px;
  background-color: ${({ transparent }) => (transparent ? 'transparent' : '#1a1a1a')};
  justify-content: center;
  display: flex;
  width: 100%;
  z-index: 999;
  position: relative;
`;

export const SubNavMobileNav = styled.div`
  background: #1a1a1a;
  height: ${props => (props.isOpen ? '100vh' : 0)};
  left: 0;
  opacity: ${props => (props.isOpen ? 1 : 0)};
  position: absolute;
  top: ${({ simpleHeader }) => (simpleHeader ? '56px' : '64px')};
  width: 100vw;
  z-index: 2147483646 !important;
  -webkit-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;

  ul {
    display: none;
    padding: 50px 28px;

    @media (max-width: 1200px) {
      display: block;
      display: ${props => (props.isOpen ? 'block' : 'none')};
    }
  }

  li {
    color: white;
    display: block;
    list-style: none;
    margin: 0 auto 20px auto;
    width: max-content;

    .toolbox-sticky-subnav--item-icon {
      width: 30px;
    }

    p {
      font-size: 18px;
      width: 90px;
      margin-left: 5px;
    }
  }

  @media (max-width: 1200px) {
    display: block;
  }
`;

export const SubscribeFormContainer = styled.div`
  position: relative;

  .toolbox-sticky-subnav--subscribe-container {
    width: 435px;
    padding: 12px;
    position: absolute;
    margin-top: 20px;
    margin-left: -80px;
    background: var(--white-color);
    box-shadow: 0px 15px 40px rgba(11, 26, 33, 0.1);
    border-radius: 2px;

    &:before {
      content: '';
      position: absolute;
      margin: auto;
      width: 20px;
      height: 20px;
      transform: rotate(225deg);
      -webkit-transform: rotate(225deg);
      -moz-transform: rotate(225deg);
      -o-transform: rotate(225deg);
      border: none;
      -ms-transform: rotate(225deg);
      border-right: 1px solid #e9eff2;
      border-bottom: 1px solid #e9eff2;
      background: transparent;
      z-index: 1000;
      margin-left: 135px;
      margin-top: -22px;
      transition: all 0.25s ease-out;
    }

    &:after {
      content: '';
      position: absolute;
      margin: auto;
      border: none;
      z-index: 999;
      margin-left: 131px;
      margin-top: -89px;
      transition: all 0.25s ease-out;
      width: 0;
      height: 0;
      border-left: 14px solid transparent;
      border-right: 14px solid transparent;
      border-bottom: 14px solid white;
    }

    & > div {
      &:first-child {
        display: none;
      }

      &:last-child {
        box-shadow: none !important;
      }

      .signup-form--form {
        .data-layer-form {
          margin-top: 0;
        }

        .ant-form-item {
          &:first-child {
            width: 100%;
            margin-right: 16px;
          }

          .text-field-wrapper {
            .text-field-input {
              width: 100%;
              height: 62px !important;
              margin-right: 0;
              padding: 16px 20px;
              font-size: 20px !important;
            }

            .text-field-helper {
              display: none;
            }
          }

          button {
            font-size: 20px;
            line-height: 110%;
            height: 62px;
            box-shadow: none;
            padding: 24px 20px;
          }
        }
      }
    }
  }

  @media (max-width: 1380px) {
    .toolbox-sticky-subnav--subscribe-container {
      margin-left: calc(50vw - 770px);

      &:before {
        margin-left: calc(825px - 50vw);
      }
      &:after {
        margin-left: calc(821px - 50vw);
      }
    }
  }

  @media (max-width: 1024px) {
    .toolbox-sticky-subnav--subscribe-container {
      margin-left: -240px;

      &:before {
        margin-left: 305px;
      }
      &:after {
        margin-left: 301px;
      }
    }
  }

  @media (max-width: 768px) {
    .toolbox-sticky-subnav--subscribe-container {
      position: fixed;
      margin-left: 0;
      right: 20px;

      & > div:last-child {
        padding: 0;
      }

      &:after {
        margin-top: -162px;
      }

      .signup-form--form {
        .ant-form-item {
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }

  @media (max-width: 576px) {
    .toolbox-sticky-subnav--subscribe-container {
      width: calc(100vw - 55px);
      left: 20px;

      & > div {
        &:first-child {
          display: block;
          font-family: 'Sofia Pro';
          font-weight: 500;
          padding: 0 0 10px;
        }
      }

      &:before {
        margin-left: calc(100vw - 177px);
      }
      &:after {
        margin-left: calc(100vw - 181px);
        margin-top: -197px;
      }
    }
  }
`;
